import store from "../store/index";
//-----------
// new round
//-----------
export default function newRound() {
  // console.log("-------------------");
  // console.log("newRound");
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let round = this_store.arena.round;
  let action = 1;
  //-----------------
  // increment round
  //-----------------
  round++;
  //-----------------
  // set return parm
  //-----------------
  let progress_parm = {
    round: round,
    action: action,
  };
  //-----------------------------
  // set view round = new round
  //-----------------------------
  store.commit("combat/setViewRound", round);
  return progress_parm;
}
